import { SwitchCase } from '@vision/ui/components';
import { ReportChartMeasureType } from '@vision/ui/interfaces';
import {
  ReportsDetailGraphicFeedbackBasedQuestionBased,
  ReportsDetailGraphicMeasureMatrixQuestion,
} from '../../../ReportsDetailGraphicMeasureComponents';

interface BarChart2MeasureRendererProps {
  measure: ReportChartMeasureType;
}

export function BarChart2MeasureRenderer({ measure }: BarChart2MeasureRendererProps) {
  return (
    <SwitchCase
      value={measure}
      caseBy={{
        'matrix-question-csat-overview': <ReportsDetailGraphicMeasureMatrixQuestion />,
        'feedback-nps': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-csat': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-ces': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-weighted-score': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
        'feedback-sentiment-score': <ReportsDetailGraphicFeedbackBasedQuestionBased />,
      }}
    />
  );
}
